import { combineReducers } from '@reduxjs/toolkit';
import authReducer from './authSlice';
import bookingReducer from './bookingSlice';
import errorReducer from './errorSlice';
import successReducer from './successSlice';
import showReducer from './showSlice';
import seatReducer from './seatSlice';
import settingReducer from './settingSlice';
import theaterReducer from './theaterSlice';
import publicReducer from './publicSlice';
import userReducer from './userSlice';

const rootReducer = combineReducers({
  auth: authReducer,
  booking: bookingReducer,
  error: errorReducer,
  success: successReducer,
  show: showReducer,
  seat: seatReducer,
  setting: settingReducer,
  theater: theaterReducer,
  user: userReducer,
  public: publicReducer,
});

export type RootState = ReturnType<typeof rootReducer>;
export default rootReducer;